import { createRouter, createWebHashHistory } from 'vue-router';
import { useModal } from '../store/index';
import { message } from 'ant-design-vue';
import { getUserInfo } from '../api/control/info';

const routes = [
  {
    path: '/',
    redirect: '/page'
  },
  {
    path: '/page',
    name: 'Page',
    component: () => import(/* webpackChunkName:"ability"*/ '@/views/page/index.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/ability/index',
    name: 'AbilityIndex',
    component: () => import(/* webpackChunkName:"ability"*/ '@/views/ability/index.vue'),
    meta: {
      title: '能力中心'
    }
  },
  {
    path: '/guide/index',
    name: 'Guide',
    component: () => import(/* webpackChunkName:"ability"*/ '@/views/guide/index.vue'),
    meta: {
      title: '快速接入'
    }
  },
  {
    path: '/interface/document',
    name: 'Interface',
    component: () => import(/* webpackChunkName:"ability"*/ '@/views/ability/interfaceDocument.vue'),
    meta: {
      title: '接口文档'
    }
  },
  {
    path: '/control',
    name: 'Control',
    component: () => import(/* webpackChunkName:"control"*/ '@/views/control/index.vue'),
    redirect: '/control/index',
    children: [
      {
        path: '/control/index',
        name: 'ControlIndex',
        component: () => import(/* webpackChunkName:"control"*/ '@/views/control/home/index.vue'),
        meta: {
          title: '首页'
        },
      },
      {
        path: '/home/range',
        name: 'HomeRange',
        component: () => import(/* webpackChunkName:"control"*/ '@/views/control/home/accountRange.vue'),
        meta: {
          title: '账户充值'
        }
      },
      {
        path: '/control/apply',
        name: 'ControlApply',
        component: () => import(/* webpackChunkName:"apply"*/ '@/views/control/apply/apply.vue'),
        meta: {
          title: '我的应用'
        }
      },
      {
        path: '/control/access',
        name: 'ControlAccess',
        component: () => import(/* webpackChunkName:"access"*/ '@/views/control/statistics/access.vue'),
        meta: {
          title: '访问统计'
        }
      },
      {
        path: '/control/userInfo',
        name: 'ControlUserInfo',
        component: () => import(/* webpackChunkName:"userInfo"*/ '@/views/control/info/userInfo.vue'),
        meta: {
          title: '我的信息'
        }
      },
      {
        path: '/control/range',
        name: 'ControlRange',
        component: () => import(/* webpackChunkName:"range"*/ '@/views/control/range/rangeOrder.vue'),
        meta: {
          title: '充值订单'
        }
      },
      {
        path: '/control/order',
        name: 'ControlOrder',
        component: () => import(/* webpackChunkName:"order"*/ '@/views/control/order/myOrder.vue'),
        meta: {
          title: '我的订单'
        }
      },
      {
        path: '/enterprise/auth',
        name: 'EnterPriseAuth',
        component: () => import(/* webpackChunkName:"auth"*/ '@/views/control/auth/EnterpriseAuth.vue'),
        meta: {
          title: '企业认证'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
});


router.beforeEach(async (to, from, next) => {
  const useModalStore = useModal();
  document.title = to.meta?.title;
  // 检测账号是否已停用
  if (useModalStore.userInfo.user_id) {
    try {
      const res = await getUserInfo({
        userId: useModalStore.userInfo.user_id
      })
      useModalStore.getUserDetail(res?.data);
      if (res?.data?.status == 2) {
        useModalStore.changeUserInfo({});
        next('/');
        sessionStorage.clear();
        localStorage.clear();
        return message.error('账号已停用，请联系客服')
      }
    } catch (err) {
      console.log(err);
    }
  }

  const toPath = to.path;
  if (!['/', '/page', '/ability/index', '/interface/document', '/guide/index'].includes(toPath) && !useModalStore.userInfo?.access_token) {
    next('/');
    message.error('请您先登录')
    useModalStore.changeModal(true)
    return
  }
  next()
})

export default router;